// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"16ac3fc9","117":"8ac5e332","161":"e2d7565d","209":"32193747","248":"bbace596","478":"02de7689","625":"d800ece9","745":"b5c83463","922":"a9748d02","964":"6b130b5d"}[chunkId] + ".chunk.js";
};